import React, { HTMLAttributes, ReactNode, useCallback } from 'react';

import { ariaOnKeyDown, cx } from '@travel/utils';

import styles from './buttonNoStyle.module.scss';

type Props = {
  isNotButton?: boolean;
  isDisabled?: boolean;
  children: ReactNode;
  onClick: () => void;
  className?: string;
} & HTMLAttributes<HTMLDivElement>;

function ButtonNoStyle(props: Props) {
  const { isNotButton, children, onClick, className, isDisabled, ...rest } = props;

  if (isNotButton) {
    return <>{children}</>;
  }

  const onClickCallback = useCallback(() => {
    if (isDisabled) {
      return;
    }
    onClick();
  }, [isDisabled, onClick]);

  return (
    <div
      data-testid="buttonNoStyle-button"
      tabIndex={isDisabled ? -1 : 0}
      {...rest}
      role="button"
      className={cx(styles.button, className)}
      onClick={onClickCallback}
      onKeyDown={ariaOnKeyDown(onClickCallback)}
      aria-disabled={isDisabled}
    >
      {children}
    </div>
  );
}

export default ButtonNoStyle;
